import React, { useContext, useEffect, useRef, useState } from "react";
import { Context } from "../../../context/Context";
import "./Thermostat.css";
import ScenarioThermostatSetTempModal from "../../modals/ScenarioThermostatSetTempModal";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";

const Thermostat = ({
  equipment_id,
  closeSelectEquipmentRef,
  closeSelectOutputEquipmentRef,
  setData,
}) => {
  const {
    handleThermostatSetTempModal,
    setThermostatSetTempModalType,
    equipmentButtons,
    devices,
  } = useContext(Context);

  const [buttons, setButtons] = useState([]);
  const [selectedButton, setSelectedButton] = useState(null);
  const [changeButton, setChangeButton] = useState(null);

  // تعریف آرایه برای نمایش ترتیب جدید: خاموش، روشن، گرمایش، سرمایش
  const displayOrder = [0, 1, 2, 3]; // ترتیب نمایش
  const modeNames = ["خاموش", "روشن", "گرمایش", "سرمایش"];

  useEffect(() => {
    // setIsLoading(true);
    // AllEquipmentButton({
    //   equipment_id: equipment_id,
    // }).then(({ data }) => {
    //   setButtons(data.equipment_buttons);
    //   setIsLoading(false);
    // });

    setButtons(
      equipmentButtons.filter((eq_btn) => eq_btn.equipment_id == equipment_id)
    );
  }, [equipmentButtons, equipment_id]);

  const handleChangeThermostatMode = (button) => {
    setSelectedButton({
      id: button.id,
      mode:
        selectedButton && selectedButton.id == button.id
          ? (selectedButton.mode + 1) % 4
          : 3,
      temp: selectedButton && selectedButton.temp ? selectedButton.temp : 25,
      diff: selectedButton && selectedButton.diff ? selectedButton.diff : 2,
    });
  };

  const handleSetTemp = (value) => {
    if (changeButton) {
      setSelectedButton((prev) => ({
        ...prev,
        id: changeButton.id,
        mode:
          selectedButton && selectedButton.id == changeButton.id
            ? selectedButton.mode
            : 3,
        temp: value,
      }));
    }
  };

  const handleSetDiff = (value) => {
    if (changeButton) {
      setSelectedButton((prev) => ({
        ...prev,
        id: changeButton.id,
        mode:
          selectedButton && selectedButton.id == changeButton.id
            ? selectedButton.mode
            : 3,
        diff: value,
      }));
    }
  };

  const modeImages = [
    "/assets/img/app-icons/zs.png", // Mode 0
    "/assets/img/app-icons/0q.png", // Mode 1
    "/assets/img/app-icons/turn-off-r.png", // Mode 2
    "/assets/img/app-icons/turn-on.png", // Mode 3
  ];

  const getModeImage = (button) => {
    if (selectedButton && selectedButton.id === button.id) {
      return modeImages[selectedButton.mode];
    }
    return modeImages[displayOrder[2]]; // Using displayMode from the displayOrder
  };

  const handleSubmit = () => {
    const button = buttons.find((btn) => btn.id == selectedButton.id);
    const device = devices.find((dev) => dev.id == button.device_id);
    if (!device) {
      return;
    }
    let data1 = Number(button.digit) + 1;
    let data2 = selectedButton.mode;
    let data3 = selectedButton.temp;
    let data4 = selectedButton.diff;

    setData({
      icon: null,
      name: button.name,
      data: [2, data1, data2, data3, data4],
      device: device,
    });
    setSelectedButton(null);
    closeSelectEquipmentRef.current.click();
    closeSelectOutputEquipmentRef.current.click();
  };

  const renderButtons = () => {
    return buttons.map((button) => (
      <div
        key={button.id}
        className="thermostat mb-3"
        style={{
          boxShadow:
            selectedButton && selectedButton.id === button.id
              ? "0 0.25rem 1rem rgba(0, 122, 255, 0.45)"
              : "0 0.25rem 1rem rgba(147, 158, 170, 0.45)",
        }}
      >
        <div className="row mx-0">
          <div className="col my-auto px-0">
            <div className="d-flex justify-content-between mb-2">
              <div>
                <span>تنظیم</span>
              </div>
              <div
                className="text-center"
                onClick={() => {
                  setChangeButton(button);
                  setThermostatSetTempModalType(1);
                  handleThermostatSetTempModal(true);
                }}
              >
                <span className="ms-1">
                  {selectedButton &&
                  selectedButton.id == button.id &&
                  selectedButton.temp != undefined
                    ? selectedButton.temp + "°C"
                    : "-"}
                </span>
              </div>
            </div>
            <div className="d-flex justify-content-between mb-2">
              <div>
                <span>تغییرات</span>
              </div>
              <div
                className="text-center"
                onClick={() => {
                  setThermostatSetTempModalType(2);
                  setChangeButton(button);
                  handleThermostatSetTempModal(true);
                }}
              >
                <span className="ms-1">
                  {selectedButton &&
                  selectedButton.id == button.id &&
                  selectedButton.diff != undefined
                    ? selectedButton.diff + "°C"
                    : "-"}
                </span>
              </div>
            </div>
          </div>

          <div
            className="col my-auto px-0 text-center"
            onClick={() => handleChangeThermostatMode(button)}
          >
            <img
              src={getModeImage(button)}
              style={{ width: "30px" }}
              alt={modeNames[0]}
            />
          </div>

          <div className="col my-auto px-0 text-center">
            <span dir="ltr">-</span>
            <div className="thermo-status bg-success"></div>
          </div>

          <div className="col my-auto px-0 text-center">
            <p className="text-center p-0 m-0 d-block">{button.name}</p>
            <div className="text-center mt-2">
              <span style={{ fontSize: "11px" }}>
                C{button.digit + 1} - S/
                {devices.find((d) => d.id == button.device_id)?.serial}
              </span>
            </div>
          </div>
        </div>
      </div>
    ));
  };

  return (
    <>
      <div className="card h-100" style={{backgroundColor: 'transparent', boxShadow: 'unset'}}>
        <div
          className="card-header d-flex align-items-center justify-content-between border-bottom p-0 pt-2"
          style={{ zIndex: 1, top: "0" }}
        >
          <h5>{buttons?.[0]?.equipment?.name ?? ""}</h5>
          <button
            type="button"
            className="btn btn-icon btn-success-app"
            onClick={handleSubmit}
          >
            <span className="tf-icons bx bx-check"></span>
          </button>
        </div>
        <div className="card-body scrollbar">
          {/* <SimpleBar style={{ maxHeight: "100%", padding: "1.5rem" }}> */}
            {renderButtons()}
          {/* </SimpleBar> */}
        </div>
      </div>
      <ScenarioThermostatSetTempModal
        selectValue={0}
        setTemp={handleSetTemp}
        setDiff={handleSetDiff}
      />
    </>
  );
};

export default React.memo(Thermostat);
